var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"cancel-collection"}},[_c('router-link',{attrs:{"id":"link_cancel-collection-five-or-less","to":"/collection-enquiry/cancel-collection-ba/five-or-less"}},[_vm._v("5 or less barcodes")]),_vm._v(" "),_c('router-link',{attrs:{"id":"link_cancel-collection-more-than-five","to":"/collection-enquiry/cancel-collection-ba/more-than-five"}},[_vm._v("More than 5 barcodes")]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcb4e956","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/CancelCollection.vue
// module id = 119
// module chunks = 0